if (!customElements.get('home-stories')) {
  customElements.define(
    'home-stories',
    class HomeStories extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
        this.videos = Array.from(this.querySelectorAll('[data-video]'));
        this.playButtons = Array.from(this.querySelectorAll('[data-play]'));
        this.muteButtons = Array.from(this.querySelectorAll('[data-mute]'));

        this.onScroll = this.onScroll.bind(this);
        this.onDotClick = this.onDotClick.bind(this);
        this.onResize = this.onResize.bind(this);

        if (this.track && this.cards.length > 0) {
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);

          for (const dot of this.dots) {
            dot.addEventListener('click', this.onDotClick);
          }

          this.updateDots();
        }

        this.playButtons.forEach((button, index) => {
          button.addEventListener('click', () => this.togglePlay(this.videos[index], button));
        });

        this.muteButtons.forEach((button, index) => {
          button.addEventListener('click', () => this.toggleMute(this.videos[index], button));
        });
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);

        for (const dot of this.dots) {
          dot.removeEventListener('click', this.onDotClick);
        }
      }

      onResize() {
        this.updateDots();
      }

      onScroll() {
        window.requestAnimationFrame(() => this.updateDots());
      }

      onDotClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        const card = this.cards[index];
        if (!card || !this.track) return;

        this.track.scrollTo({
          left: card.offsetLeft,
          behavior: 'smooth',
        });
      }

      updateDots() {
        if (!this.track || this.dots.length === 0) return;

        const scrollLeft = this.track.scrollLeft;
        let activeIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      togglePlay(video, button) {
        if (!video) return;

        if (video.paused) {
          video.play();
          button.classList.add('is-playing');
        } else {
          video.pause();
          button.classList.remove('is-playing');
        }
      }

      toggleMute(video, button) {
        if (!video) return;

        video.muted = !video.muted;
        button.classList.toggle('is-muted', !video.muted);
      }
    }
  );
}
